import { render, staticRenderFns } from "./publish-input.vue?vue&type=template&id=aad68f26&scoped=true"
import script from "./publish-input.vue?vue&type=script&lang=js"
export * from "./publish-input.vue?vue&type=script&lang=js"
import style0 from "./publish-input.vue?vue&type=style&index=0&id=aad68f26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad68f26",
  null
  
)

export default component.exports